import React, { useEffect } from "react";

import PropTypes from "prop-types";
import { connect } from "react-redux";

import Loading from "../../../components/Loading";
import DockTabComponent from "../../../components/ScheduleConfig/DockTabComponent";

import useStyles from "./styles";
import { getDataStorage } from "../../../utils/filterManagementDataStore";

const DockTab = ({
  docks,
  branches,
  filter,
  loadProducts,
  loadPlants,
  plants,
  loadLoadingTypes,
  loadingTypes,
  products,
  setFilter,
  loadDocks,
  cleanDocks,
  cleanPlants,
  deleteDock,
  addDock,
  updateDock,
  subRoutes,
  docksLoading,
  docksError,
  clearDockErrors,
  getNotificationsFromSchedConfigAsync
}) => {
  const classes = useStyles();

  const removeItem = (data) => deleteDock(data);
  const addItem = (dockData) => addDock(dockData);
  const updateItem = (dockData) => updateDock(dockData);
  const getNotifications = () => getNotificationsFromSchedConfigAsync();

  useEffect(() => {
    const branchId = filter.dockBranch || getDataStorage('dock_config_checkSingleBranch')?.value;
    const plant = filter.dockPlant || getDataStorage('dock_config_checkDocksPlant')?.value;

    if (branchId) {
      loadPlants(branchId);
    } else {
      cleanPlants();
    }

    if (plant) {
      loadDocks(plant);
    } else {
      cleanDocks();
    }

  }, [loadPlants, loadDocks, filter.dockBranch, filter.dockPlant, cleanDocks, cleanPlants]);

  useEffect(() => {
    const plant = filter.dockPlant || getDataStorage('dock_config_checkDocksPlant')?.value;

    if(plant) {
      loadDocks(plant);
    } else {
      cleanDocks();
    }

  }, [loadDocks, filter.dockPlant, cleanDocks]);

  useEffect(() => {
    loadProducts();
  }, [loadProducts]);

  useEffect(() => {
    loadLoadingTypes();
  }, [loadLoadingTypes]);

  return (
    <div className={classes.root}>
      {docksLoading && <Loading />}
      <DockTabComponent
        subRoutes={subRoutes}
        docks={docks}
        products={products}
        plants={plants}
        loadingTypes={loadingTypes}
        onDeleteItem={removeItem}
        onAddItem={addItem}
        onUpdateItem={updateItem}
        branches={branches}
        filter={filter}
        setFilter={setFilter}
        docksError={docksError}
        clearDockErrors={clearDockErrors}
        getNotificationsFromSchedConfigAsync={getNotifications}
      />
    </div>
  );
};

const filterProductsByLoadType = (dock, products, idloadType) =>
  dock.dockTypes
    .filter((dockType) => dockType.id_load_type === idloadType)
    .map((_dockType) => {
      const prod = products.find(
        (product) => product.id === _dockType.id_product
      );
      return prod ? prod.name : "";
    });

const mapState = ({
  docks: { docks, loading, error },
  notifications,
  products: { products },
  loadTypes: { types },
  plants: { plants },
}) => ({
  docksLoading: loading,
  docksError: error,
  notifications: notifications.allNotifications,
  docks: docks.map((dock) => {
    let carrega = [];
    let descarrega = [];

    if (types && types.length) {
      const idCarrega = types.find((t) => t.description === "Carga").id;
      const idDescarrega = types.find((t) => t.description === "Descarga").id;
      carrega = filterProductsByLoadType(dock, products, idCarrega);
      descarrega = filterProductsByLoadType(dock, products, idDescarrega);
    }
    return {
      ...dock,
      value: dock.id,
      label: dock.name,
      carrega: carrega,
      descarrega: descarrega,
    };
  }),
  products: products.map((product) => ({
    ...product,
    value: product.id,
    label: product.name,
  })),
  plants: plants.map((plant) => ({
    ...plant,
    value: plant.id,
    label: plant.name + " - " + plant.bp_number,
  })),
  loadingTypes: types.map((type) => ({
    ...type,
    value: type.id,
    label: type.description,
  })),
});
const mapDispatch = (dispatch) => ({
  loadProducts: () => dispatch.products.loadAsync(),
  loadLoadingTypes: () => dispatch.loadTypes.loadAsync(),
  loadDocks: (idPlant) => dispatch.docks.loadAsync(idPlant),
  loadPlants: (idBranch) => dispatch.plants.loadAsync(idBranch),
  addDock: (data) => dispatch.docks.addAsync(data),
  updateDock: (data) => dispatch.docks.updateAsync(data),
  deleteDock: (id) => dispatch.docks.deleteAsync(id),
  cleanDocks: () => dispatch.docks.setDocks([]),
  cleanPlants: () => dispatch.plants.setPlants([]),
  clearDockErrors: (payload) => dispatch.docks.clearDockErrors(payload),
  getNotificationsFromSchedConfigAsync: () => dispatch.notifications.getNotificationsFromSchedConfigAsync()
});

DockTab.propTypes = {
  docks: PropTypes.array.isRequired,
  products: PropTypes.array.isRequired,
  branches: PropTypes.array.isRequired,
  plants: PropTypes.array.isRequired,
  loadingTypes: PropTypes.array.isRequired,
  filter: PropTypes.object.isRequired,
  setFilter: PropTypes.func.isRequired,
  loadDocks: PropTypes.func.isRequired,
  cleanDocks: PropTypes.func.isRequired,
  cleanPlants: PropTypes.func.isRequired,
  loadProducts: PropTypes.func.isRequired,
  loadLoadingTypes: PropTypes.func.isRequired,
  deleteDock: PropTypes.func.isRequired,
  addDock: PropTypes.func.isRequired,
  updateDock: PropTypes.func.isRequired,
  subRoutes: PropTypes.array.isRequired,
  docksLoading: PropTypes.bool.isRequired,
  clearDockErrors: PropTypes.func.isRequired,
  getNotificationsFromSchedConfigAsync: PropTypes.func.isRequired
};

export default connect(mapState, mapDispatch)(DockTab);
